import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Save Hours Every Week',
    desc: 'Stop wasting Sundays planning classes.'
  }, {
    emoji: '👑',
    title: 'Teach With Confidence',
    desc: 'Walk into every class fully prepared.'
  }, {
    emoji: '🌱',
    title: 'Improve Student Results',
    desc: 'Use structured progressions designed for long-term success.'
  }, {
    emoji: '💎',
    title: 'Increase Your Professional Authority',
    desc: 'Become the instructor students trust and recommend.'
  }, {
    emoji: '😌',
    title: 'Reduce Mental Stress',
    desc: 'Spend more time teaching and less time preparing.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-33">
      <div className="max-w-5xl mx-auto" data-id="element-34">
        <div className="text-center mb-12" data-id="element-35">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-36">
            WHAT WILL CHANGE FOR YOU?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-37">
            What will change in your{' '}
            <span className="italic text-pilates-rose" data-id="element-38">professional life</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-39">
          {benefits.map((b, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/15 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-40">
              <div className="text-4xl mb-3" data-id="element-41">{b.emoji}</div>
              <h3 className="font-display font-semibold text-pilates-dark text-xl mb-2 leading-tight" data-id="element-42">
                {b.title}
              </h3>
              <p className="text-pilates-slate text-base leading-relaxed" data-id="element-43">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}